export default {
  "about": {
    "careersDetails": {
      "anqing": "آنجينغ",
      "applyResume": "تقديم السيرة الذاتية",
      "backToPrevious": "العودة إلى الصفحة السابقة",
      "category": "الفئة:",
      "education": "أدنى مستوى تعليمي:",
      "errors": {
        "getInfoFailed": "فشل الحصول على المعلومات",
        "getJobDetailFailed": "فشل الحصول على تفاصيل الوظيفة",
        "getJobDetailFailedRetry": "فشل الحصول على تفاصيل الوظيفة، يرجى المحاولة لاحقًا",
        "jobNotExist": "معلومات الوظيفة غير موجودة",
        "parseInfoFailed": "فشل تحليل المعلومات"
      },
      "jobDescription": "وصف الوظيفة",
      "jobRequirements": "متطلبات التوظيف",
      "nationwide": "في جميع أنحاء البلاد",
      "noJobInfo": "معلومات الوظيفة غير موجودة",
      "person": "شخص",
      "recruitmentCount": "عدد المتقاعدين:",
      "salary": "الشروط الأجارية:",
      "suzhou": "سو",
      "workLocation": "موقع العمل:",
      "workYear": "سنوات الخبرة:"
    },
    "contact": {
      "address": "العنوان:",
      "contactInfo": "معلومات الاتصال",
      "email": "البريد الإلكتروني:",
      "errors": {
        "getContactFailed": "فشل الحصول على بيانات معلومات الاتصال"
      },
      "pageTitle": "اتصل بنا",
      "phone": "الهاتف:",
      "postcode": "الرمز البريدي:"
    },
    "page": {
      "careers": {
        "activities": {
          "balance": {
            "description": "تشجع على توازن بين العمل والحياة",
            "subtitle": "الاحتفاظ بالتوازن",
            "title": "التوازن للمستقبل"
          },
          "learning": {
            "description": "إنشاء منظمة تعليمية، وتشجيع التعلم مدى الحياة",
            "subtitle": "الاستمرار في التعلم",
            "title": "لا نهاية للتعلم"
          }
        },
        "category": "الفئة:",
        "errors": {
          "getAreaFailed": "فشل الحصول على موقع العمل",
          "getAreaFailedRetry": "فشل الحصول على موقع العمل، يرجى المحاولة لاحقًا",
          "getCategoryFailed": "فشل الحصول على فئات الوظائف",
          "getCategoryFailedRetry": "فشل الحصول على فئات الوظائف، يرجى المحاولة لاحقًا",
          "getJobsFailed": "فشل الحصول على قائمة الوظائف",
          "getJobsFailedRetry": "فشل الحصول على قائمة الوظائف، يرجى المحاولة لاحقًا",
          "getNatureFailed": "فشل الحصول على طبيعة العمل",
          "getNatureFailedRetry": "فشل الحصول على طبيعة العمل، يرجى المحاولة لاحقًا"
        },
        "jobCategory": "فئات الوظائف",
        "jobNature": "طبيعة العمل",
        "nationwide": "في جميع أنحاء البلاد",
        "noData": "لا توجد بيانات حاليًا",
        "noJobs": "لا توجد وظائف مرتبطة حاليًا",
        "publishDate": "نشر في",
        "searchBox": {
          "campusRecruitment": "التوظيف الجامعي",
          "placeholder": "الرجاء إدخال الكلمات المفتاحية",
          "search": "بحث",
          "socialRecruitment": "التوظيف الاجتماعي"
        },
        "viewDetail": "عرض التفاصيل>",
        "workLocation": "موقع العمل"
      },
      "company": {
        "companyIntro": "تأسست في عام 2003 ومقرها في سوتشو بالصين، وبعد سنوات من التطوير المبتكر، أصبحت شركة وطنية عالية التقنية تجمع بين البحث والتطوير والإنتاج والمبيعات والخدمة. يغطي نطاق أعمالها علوم الحياة، والعناية الشخصية، والمواد الجديدة، واختيار المنتجات البحثية، والاختبارات، وما إلى ذلك.",
        "companyName": "شركة ياكو (Yacoo)",
        "dataSection": {
          "founded": "التأسيس",
          "globalCustomers": "العملاء العالميين",
          "globalPartners": "الشركاء العالمية في النظام البيئي",
          "patents": "البراءات الاختراعية المُقدمة في الخارج والداخل",
          "productionBase": "قدرة الإنتاج السنوية",
          "salesCountries": "الدول والأقاليم المُرتبطة بالمبيعات",
          "title": "بيانات الشركة",
          "unit": "طن",
          "year": "عام"
        },
        "history": {
          "title": "دورة التطوير"
        },
        "honor": {
          "title": "الشهادات والجوائز"
        },
        "pageTitle": "عن الشركة",
        "subtitle": "شركة Yacoo Science هي الرائد المبتكر في مواد الكيمياء الطبية العالمية.",
        "vision": {
          "mission": {
            "description": "الالتزام بالتقدم التكنولوجي والتحول في مواد الطب والكيمياء",
            "title": "الرسالة"
          },
          "title": "فلسفة الشركة",
          "values": {
            "description": "النزاهة والامتنان، المسؤولية والالتزام، العمل الواقعي والجهد الجاد، الابتكار والتميز",
            "title": "القيم الأساسية"
          },
          "vision": {
            "description": "الان  الرائدة العالمية في الابتكار في مواد الطب والكيمياء",
            "title": "الرؤية"
          }
        }
      },
      "production": {
        "intro": "تمتلك شركة ياكو (Yacoo) قدرة تصنيع ثابتة وموثوقة. حاليًا، أنشأت مواقع إنتاجية في جينينغ وسو، مزودة بتجهيزات إنتاجية وتقنيات إنتاجية رائدة عالميًا، وتركز على البحث والتطوير والإنتاج من المواد الكيميائية الدقيقة عالية الجودة. تُقدِّر قدرة الإنتاج الإجمالية لكل موقع إنتاجي أكثر من 100,000 طن سنويًا، وقد حصلت على شهادة نظام إدارة الجودة ISO9001، وشهادة نظام إدارة البيئة ISO14001، وشهادة نظام إدارة السلامة المهنية الصحية ISO45001.",
        "intro2": "تستخدم شركة ياكو (Yacoo) نظام ضبط الجودة \"دون عيوب\" لضمان أن يُصل كل دفعة من المنتجات إلى المستوى العالي في الصناعة، وتستمر في تقديم حلول توريد موثوقة ومستقرة من المواد الكيميائية لعملاءها العالميين. بناءً على المزايا التنافسية مثل القدرة الإنتاجية على نطاق واسع، الإنتاج الذكي، ضبط المواد الأولية في جميع الخطوات، توفر حلولًا شاملة للمواد الأولية \"من البحث العلمي إلى الإنتاج التجاري\" لمجالات الصناعات الناشئة الاستراتيجية مثل الرعاية الصحية والجزيئات الحيوية، للمساعدة العملاء على تحقيق تنمية سليمة.",
        "siteInfo": {
          "area": "مساحة التأطير:",
          "capacity": "المصانع وقدرة الإنتاج:",
          "coreProducts": "المنتجات الرئيسية:",
          "field": "مجالات التطبيق:"
        },
        "title": "مواقع الإنتاج"
      },
      "quality": {
        "equipment": {
          "description": "عن طريق إنشاء منصة شاملة من أجهزة الاختبار، بما في ذلك مقاييس الكروماتوجرافيا السائلة العالية الكفاءة، ومقاييس الكروماتوجرافيا الغازية، ومقاييس الرنين المغناطيسي النووي، ومقاييس الانحراف البصري، ومقاييس الطيف الفيضي الأحمر، ومقاييس الطيف الفيضي للإشعاع المتصل بالبلازما الحرة، ومقاييس النقطة التفاضلية الآلية، ومقاييس محتوى الماء بالطريقة الكارليزية الكولومبية، يمكن لشركة ياكو (Yacoo) تلبية احتياجات العملاء من اختبارات الافراج عالية الدقة والعقوبة العالية في مختلف السيناريوهات المتأثرة.",
          "devices": {
            "automaticTitrator": "مقياس النقطة التفاضلية الآلية",
            "broadbandNMR": "مقياس الرنين المغناطيسي النووي متعدد الملفوفات العريضة",
            "gcms": "مقياس الكروماتوجرافيا الغازية - القياس الكتلي (GC-MS)",
            "icpSpectrometer": "مقياس الطيف الفيضي للإشعاع المتصل بالبلازما الحرة",
            "infraredSpectrometer": "مقياس الطيف الفيضي الأحمر",
            "karlFischer": "مقياس محتوى الماء بالطريقة الكارليزية الكولومبية"
          },
          "title": "أجهزة الاختبار"
        },
        "intro": "تعتمد شركة ياكو (Yacoo) على ضبط العمليات لضمان جودة المنتجات، وتركز على تقديم منتجات متنوعة ذات قيمة مضافة عالية، وخدمات أفضل لعملائها، وتعتبر خدمة الابتكار لعملائها من واجباتها الرئيسية. بناءً على تجربة شركة ياكو (Yacoo) البالغة 22 عامًا في مجال اختبار مواد الطب والكيمياء، وتشكيل فريق تحليلي بحثي يرأسه عدة دكاتر، توفر حلولًا شاملة من الاختبار إلى تحسين التقنية لعملائها.",
        "intro2": "تحتوي منصة الاختبارات التابعة لشركة ياكو (Yacoo) على مختبرات عصرية بسعة 3000 متر مربع، وقد أنشئت نظامًا متطورًا عالميًا لتدوير الهواء والتطهير، لضمان أن بيئة الاختبار آمنة ومُضبطة. تم تجهيز المنصة بمساحات تحليل كيميائي شاملة وأجهزة عالية المستوى الكاملة، لتلبية احتياجات الاختبارات عالية الدقة والعقوبة العالية. بناءً على القوانين واللوائح التقنية في جميع الدول والأقاليم (مثل REACH الأوروبي، وFDA الأمريكية، وCDE الصينية)، تساعد الشركة العملاء على تجنب الحواجز التجارية، وتحقيق إدارة متوافقة على دورة حياة المنتج الكاملة.",
        "navigation": {
          "next": "التالي",
          "prev": "السابق"
        },
        "system": {
          "description": "أنشأت شركة ياكو (Yacoo) نظامًا شاملاً ومتكاملًا لاختبار مواد الطب والكيمياء يغطي التميز البنائي، والخصائص الفيزيائية والكيميائية، والتحليل العنصري، والتحليل الطيفي، ودراسات الاستقرار، والانضباط الكامل والمتتبع للبيانات، ودراسات تحليل الملوثات، واختبارات المواد الأولية. تمتلك إدارة الجودة شهادة نظام GMP، وشهادة نظام إدارة الجودة ISO9001:2015، لدعم تطبيقات العملاء في الأسواق العالمية.",
          "title": "نظام الاختبار"
        },
        "title": "إدارة الجودة"
      }
    },
    "tabs": {
      "careers": "انضم إلينا",
      "company": "عن الشركة",
      "production": "مواقع الإنتاج",
      "quality": "إدارة الجودة"
    }
  },
  "dzhc": {
    "businessIntroText": "الخدمات المُخصصة هي نشاط رائيسي لشركة ياكو (Yacoo). بناءً على تجربة البحث والتطوير البالغة 22 عامًا في مجال مواد الطب والكيمياء، يمكن لشركة ياكو (Yacoo) تقديم خدمات مُخصصة شاملة وموثوقة ومستقرة لعملائها. تمتلك فريقًا بحثيًا ومراقب جودة مُكون من علماء ومهندسين مُتقنين، و أنشأت 5 منصات تجريبية مثل منصة التركيب الذكية بالذكاء الاصطناعي، ومنصة التركيب الكيميائي، ومنصة التركيب الحيوي، ومزودة بمنصات اختبار متطورة مثل مقاييس الكروماتوجرافيا السائلة العالية الكفاءة، ومقاييس الكروماتوجرافيا الغازية، ومقاييس الانحراف البصري. علاوة على ذلك، تمتلك شركة ياكو (Yacoo) 2 مواقع إنتاجية بقدرة إنتاجية تُقدِّر أكثر من 100,000 طن سنويًا، مما يمكنها تلبية احتياجات العملاء في مجال مواد الطب والكيمياء من التركيب المُخصص، وخدمات CRO، وحتى خدمات CDMO في جميع الخطوات.",
    "businessIntroTitle": "نظرة عامة على الأنشطة",
    "businessItems": ["المواد العضوية العالية الجودة", "الوحدات الأولية البوليمرية", "المواد الوسيطة الدوائية", "المواد العضوية الجديدة للإلكترونيات", "المواد الأولية لاختبارات السريرية"],
    "caseTabs": [
      {"title": "فريق خبراء في مجال الطب والكيمياء", "description": "مُكون من مئات العلماء المهندسين الخبراء، يُقدِّر أن نسبة المُعلمين بالدرجات العليا (الماجستير والدكتوراه) تزيد عن 40%، وعدد البراءات الاختراعية المُقدمة في مجال البحث والتطوير يزيد عن 150 براءة اختراعية، وعدد البراءات الاختراعية المعتمدة يزيد عن 50 براءة اختراعية."},
      {"title": "منصة بحث وتطوير واختبار رائدة", "description": "أنشأت 5 منصات تجريبية مثل منصة التركيب الذكية بالذكاء الاصطناعي، ومنصة التركيب الكيميائي، ومنصة التركيب الحيوي، ومزودة بمنصات اختبار متطورة مثل مقاييس الكروماتوجرافيا السائلة العالية الكفاءة، ومقاييس الكروماتوجرافيا الغازية، ومقاييس الانحراف البصري."},
      {"title": "ضمان نظام جودة دولي", "description": "الالتزام بالمعايير الدولية ISO، وضبط الجودة في جميع الخطوات، لضمان المواد عالية الموثوقية. من اختيار المواد الأولية إلى المنتج النهائي، هناك نقاط اختبار متعددة المستويات، وضبط الجودة في جميع الخطوات."}
    ],
    "coreBusinessTitle": "الأنشطة الرئيسية",
    "featureTitle": "ميزات الخدمة",
    "pageSubtitle": "خدمات CRO+CDMO المُخصصة لمنتجات الطب والكيمياء",
    "pageTitle": "الخدمات المُخصصة",
    "processItems": [
      {"title": "تصميم المسارات", "desc": ["أكثر من 100 موظف بحثي ذو خبرة", "تصميم مسارات التركيب بمساعدة الذكاء الاصطناعي"]},
      {"title": "البحث والتطوير والتركيب", "desc": ["مختبرات بحث وتطوير بسعة أكثر من 10,000 متر مربع", "تغطية 80% من التفاعلات الشائعة"]},
      {"title": "تصميم المسارات", "desc": ["أكثر من 100 موظف بحثي ذو خبرة", "تصميم مسارات التركيب بمساعدة الذكاء الاصطناعي"]},
      {"title": "البحث والتطوير والتركيب", "desc": ["مختبرات بحث وتطوير بسعة أكثر من 10,000 متر مربع", "تغطية 80% من التفاعلات الشائعة"]},
      {"title": "إنتاج النماذج التجريبية", "desc": ["مصانع بسعة أكثر من 200,000 متر مربع", "ضبط جودة صارم، ضمان الجودة"]},
      {"title": "التعبئة والشحن", "desc": ["التلبية لجميع متطلبات التعبئة والشحن للمواد الصلبة/السائلة", "الشحن للنماذج التجريبية/متابعة الشحن"]}
    ],
    "processTitle": "عملية التركيب المُخصص",
    "startProject": "ابدأ مشروعك المُخصص على الفور",
    "startProjectDesc": "اطلب احتياجاتك، وسيقدم لك فريق متخصص استشارات تقنية فردية وحلول مُخصصة.",
    "viewMore": "عرض المزيد"
  },
  "header": {
    "contactUs": "اتصل بنا",
    "menu": {
      "about": "عن ياكو",
      "companyProfile": "ملف الشركة",
      "customSynthesis": "التركيب المُخصص",
      "greenEnergy": "الطاقة الخضراء",
      "innovation": "نتائج الابتكار",
      "joinUs": "انضم إلينا",
      "news": "مركز الأخبار",
      "other": "أنشطة أخرى",
      "production": "مواقع الإنتاج",
      "products": "مركز المنتجات",
      "quality": "إدارة الجودة",
      "rAndDSystem": "نظام البحث والتطوير",
      "researchPurchase": "شراء البحث العلمي",
      "smartPlatform": "المنصة الذكية",
      "solution": "حلول الصناعة",
      "sustainability": "التنمية المستدامة",
      "technology": "البحث والتطوير والابتكار",
      "testingService": "خدمات الاختبار"
    },
    "searchPlaceholder": "الرجاء إدخال محتوى البحث..."
  },
  "home": {
    "about": {
      "description": "تأسست في عام 2003 ومقرها في سوتشو بالصين، وبعد سنوات من التطوير المبتكر، أصبحت شركة وطنية عالية التقنية تجمع بين البحث والتطوير والإنتاج والمبيعات والخدمة. يغطي نطاق أعمالها علوم الحياة، والعناية الشخصية، والمواد الجديدة، واختيار المنتجات البحثية، والاختبارات، وما إلى ذلك.",
      "learnMore": "تعرف المزيد",
      "subtitle": "شركة Yacoo Science هي الرائد المبتكر في مواد الكيمياء الطبية العالمية.",
      "title": "عن ياكو"
    },
    "globalService": {
      "description": "يمكن لشركة ياكو (Yacoo) تقديم خدمات CRO+CMO شاملة لعملاءها العالميين من التركيب المُخصص إلى الإنتاج على نطاق واسع، لتلبية احتياجات منتجاتك في جميع الخطوات من البحث العلمي إلى الإنتاج التجاري.",
      "legend": {
        "customers": {
          "en": "Our Customers",
          "zh": "العملاء"
        },
        "headquarters": {
          "en": "Yacoo Headquarter",
          "zh": "مقر ياكو الرئيسي"
        },
        "subsidiaries": {
          "en": "Subsidiary Companies",
          "zh": "شركات ياكو التابعة"
        }
      },
      "stats": {
        "title": "التوزيع الخارجي",
        "capacity": "إنشاء شركات تابعة في سنغافورة، والولايات المتحدة، وال герماني",
        "patents": "عدد العملاء العالميين يزيد عن 15,000 شركة",
        "team": "التغطية الأعمالية في أكثر من 70 دولة في العالم"
      },
      "title": "شبكة الخدمات العالمية"
    },
    "news": {
      "noNews": "لا توجد أخبار مرتبطة حاليًا",
      "pageTitle": "مركز الأخبار",
      "searchPlaceholder": "الرجاء إدخال الكلمات المفتاحية",
      "title": "أحداث ياكو",
      "topTag": "مُعينًا",
      "viewDetail": "تعرف التفاصيل",
      "viewMore": "عرض المزيد"
    },
    "solutions": {
      "title": "المنتجات والحلول"
    }
  },
  "jcfw": {
    "businessIntroText1": "ووندر تيست (Wonder Testing) هو منصة خدمات اختبار مستقلة تابعة لشركة ياكو (Yacoo). بناءً على تجربة اختبار شركة ياكو (Yacoo) البالغة 22 عامًا في مجال مواد الطب والكيمياء، يهدف ووندر تيست (Wonder Testing) إلى بناء منصة خدمات جودة دولية، بناءً على الاعتماد على الاعتماد CMA (الاعتماد المتري الصيني) والاعتماد على مختبرات CNAS (ISO/IEC 17025) لتقديم خدمات اختبار، وتصديق، وخدمات استشارية مرتبطة لشركات التصنيع/شركات التجارة المحلية/الخارجية وفقًا لقوانين/لوائح/مشروعات تقنية (لجميع الدول/الأقاليم). وتقديم حلول شاملة من الاختبار إلى تحسين التقنية لعملائها.",
    "businessIntroText2": "تحتوي منصة ووندر تيست (Wonder Testing) على مختبرات عصرية بسعة 3000 متر مربع، وقد أنشئت نظامًا متطورًا عالميًا لتدوير الهواء والتطهير، لضمان أن بيئة الاختبار آمنة ومُضبطة. تم تجهيز المنصة بمساحات تحليل كيميائي شاملة وأجهزة عالية المستوى الكاملة، لتلبية احتياجات الاختبارات عالية الدقة والعقوبة العالية. بناءً على القوانين واللوائح التقنية في جميع الدول والأقاليم (مثل REACH الأوروبي، وFDA الأمريكية، وCDE الصينية)، تساعد الشركة العملاء على تجنب الحواجز التجارية، وتحقيق إدارة متوافقة على دورة حياة المنتج الكاملة.",
    "businessIntroTitle": "نظرة عامة على الأنشطة",
    "businessItems": ["خدمات الاختبار والفحص", "البحث الطبى والتطوير التجريبي", "خدمات اختبارات التقنية", "خدمات التصديق"],
    "businessItemsClass": ["المنتجات المستهلكية", "المنتجات الإلكترونية والكهربائية", "الألعاب ومتجات الأطفال", "المواد المتصلة بالطعام", "معدن السيارات", "المنتجات الخفيفة والمنسوجات"],
    "businessTip": "أنشأت المختبرات نظامًا شاملاً لخدمات الاختبار، والذي يمكنه تلبية احتياجات الاختبارات الكيميائية والفيزيائية لمنتجات المستهلك، والمنتجات الإلكترونية والكهربائية، والألعاب ومتجات الأطفال، والمنتجات المتصلة بالطعام، ومعدن السيارات، والمنتجات الخفيفة والمنسوجات، وما إلى ذلك.",
    "caseTabs": [
      {"title": "تجربة اختبار وتصديق متوافق", "description": "تعتمد المختبرات على تجربة خدمات اختبار شركة ياكو (Yacoo) البالغة 22 عامًا في مجال الطب والكيمياء، وتهدف إلى تقديم خدمات اختبار متوافق، وتصديق، وخدمات استشارية تقنية لشركات التصنيع والتجارة العالمية."},
      {"title": "الاعتماد على نظام معايير دولي", "description": "تتوافق مؤشرات الاختبار والنظم الإدارية مع متطلبات أنظمة الجودة الدولية، وقد حصلت على الاعتماد من العديد من العملاء الرائدة دوليًا، لضمان السلطة والاعتماد على بيانات الاختبار."},
      {"title": "التغطية الشاملة لقدرات الاختبار", "description": "تقديم خدمات شاملة في مجال اختبار الكيمياء للمستحضرات الاستهلاكية، وتقييم أمان الألعاب للأطفال، واختبار المنسوجات، واختبار متوافق للمواد المتصلة بالطعام، وتحليل معدن السيارات، وما إلى ذلك، للمساعدة الشركات على مواجهة متطلبات اللوائح الوطنية (مثل REACH، وFDA، وCDE، وما إلى ذلك)."
      }
    ],
    "contact": {
      "address": "العنوان: الطابق 8، مبنى 112، شارع سينغ تشينغ، ميناء سو الصناعي",
      "email": "البريد الإلكتروني للاتصال: service@wondertesting.cn",
      "phone": "الهاتف: +86-18625246998",
      "postcode": "الرمز البريدي: 215121"
    },
    "contactTitle": "اتصل بنا",
    "coreBusinessTitle": "الأنشطة الرئيسية",
    "equipmentDesc": "عن طريق إنشاء منصة شاملة من أجهزة الاختبار، بما في ذلك مقاييس الكروماتوجرافيا السائلة العالية الكفاءة، ومقاييس الكروماتوجرافيا الغازية، ومقاييس الرنين المغناطيسي النووي، ومقاييس الانحراف البصري، ومقاييس الطيف الفيضي الأحمر، وما إلى ذلك، يمكن لشركة ياكو (Yacoo) تلبية احتياجات العملاء من اختبارات الافراج عالية الدقة والعقوبة العالية في مختلف السيناريوهات المتأثرة.",
    "equipmentList": ["مقياس الطيف الفيضي الأحمر", "مقياس الرنين المغناطيسي النووي متعدد الملفوفات العريضة", "مقياس الطيف الفيضي للإشعاع المتصل بالبلازما الحرة", "مقياس محتوى الماء بالطريقة الكارليزية الكولومبية", "مقياس الكروماتوجرافيا الغازية - القياس الكتلي (GC-MS)", "مقياس النقطة التفاضلية الآلية"],
    "equipmentTitle": "أجهزة الاختبار",
    "featureTitle": "ميزات الخدمة",
    "nextBtn": "التالي",
    "pageSubtitle": "مزود متكامل من الاختبار المستقلة إلى تحسين التقنية",
    "pageTitle": "خدمات الاختبار",
    "platformDesc": "مزود متكامل لخدمات الاختبار والتصديق",
    "prevBtn": "السابق",
    "shopSubtitle": "مزود متكامل من الاختبار المستقلة إلى تحسين التقنية",
    "shopTitle": "ووندر تيست (Wonder Testing)",
    "viewMore": "عرض المزيد"
  },
  "kycg": {
    "businessIntroText": "منصة ب2ستار (www.b2star.com)  هي منصة تجارة إلكترونية لشراء البضائع البحث العلمي تابعة لشركة ياكو (Yacoo). عن طريق دمج قنوات الموردين العلامة التجارية المحلية والخارجية، تقدم المنتجات مثل المُحاليل البحث العلمي، ومتجات الحماية، والمواد المستهلكة الحيوية، ومعدن التجربة، وما إلى ذلك، وتهدف إلى تلبية احتياجات متنوعة لعملاء المجالات مثل أبحاث علوم الحياة، والدواء الحيوي، والمواد الجديدة، وما إلى ذلك، في الخارج والداخل.",
    "businessIntroTitle": "نظرة عامة على الأنشطة",
    "businessItems": [
      {"title": "المُحاليل البحث العلمي", "desc": "المُحاليل الحيوية، والمُحاليل الكيميائية، والمُحاليل التحليلية، ومُحاليل أخرى"},
      {"title": "متجات الحماية", "desc": "الحماية اليدوية، والحماية الرأسية، والحماية الوجهية، ومتجات الحماية الأخرى"},
      {"title": "المواد المستهلكة الحيوية", "desc": "الزراعة الخلية، والمواد المستهلكة الطبية، والمواد المستهلكة للكروماتوجرافيا، والمواد المستهلكة للاختبار، والمواد المستهلكة لنقل السوائل، والمواد المستهلكة الأدواتية"},
      {"title": "معدن التجربة", "desc": "الأدوات العادية، والأدوات للاختبار، والأدوات للكروماتوجرافيا، والأدوات، والمرافق الأمنية"}
    ],
    "caseTabs": [
      {"title": "استجابة الشحن في 24 ساعة", "description": "الشحن المباشر من عدة مخازن، التوصيل السريع"},
      {"title": "أكثر من 6 ملايين نوع من المنتجات", "description": "العلامات التجارية العديدة، التنوع في الأنواع"},
      {"title": "أكثر من 600 علامة تجارية شراكية", "description": "الاعتماد من الشركة المصنعة، ضمان الأصالة"},
      {"title": "خدمات شراء", "description": "الاستفادة العديدة، الخدمة"}
    ],
    "contact": {
      "addressSuqian": "العنوان (سو تشيان): الطابق الأول، مبنى جو كيه (A9)، حديقة التجارة الإلكترونية، منطقة سو يو، مدينة سو تشيان",
      "addressSuzhou": "العنوان (سو): شارع سينغ تشينغ 112، ميناء سو الصناعي",
      "addressWuhan": "العنوان (ووهان): الطابق 11، غرفة 07، مبنى تي 3، مركز ميناء قوانغجو، شارع غاوشن 766، منطقة التكنولوجيا الجديدة شرق hồ ووهان",
      "addressChengdu": "العنوان (شنغدو): غرفة 706، مبنى 3، دينغ شينغ الكتروني، شارع ووكسي 1 غرب، منطقة ووحو، مدينة شنغدو",
      "email": "البريد الإلكتروني: sxg@b2star.com",
      "phone": "الهاتف: 15335295587"
    },
    "contactTitle": "اتصل بنا",
    "coreBusinessTitle": "الأنشطة الرئيسية",
    "enterShop": "الدخول للإلغاء",
    "featureTitle": "ميزات الخدمة",
    "pageSubtitle": "منصة شاملة لشراء البحث العلمي",
    "pageTitle": "شراء البحث العلمي",
    "shopBusiness": ["المُحاليل البحث العلمي", "الحماية الأمنية", "المواد المستهلكة الحيوية", "معدن التجربة"],
    "shopSubtitle": "منصة شاملة لشراء البحث العلمي",
    "shopTitle": "منصة ب2ستار "
  },
  "lsny": {
    "businessIntroText": "جودينغ نيو إنرجي (www.goodenoughchem.com) (Goodenough New Energy) هي منصة خدمات الطاقة الخضراء تابعة لشركة ياكو (Yacoo). المُعالج المتصل المُ الذاتي المُطوّر ذاتيًا، يُحسن أمان البطارية بشكل فعال، وقد حصل على الاعتماد من العديد من شركات التعاون الرائدة. بوصفها مزودًا متكاملاً لمواد البطارية الل للطاقة العضوية، يمكن لجودينغ نيو إنرجي (Goodenough New Energy) تلبية احتياجاتك من الاحتياجات البحثية إلى الإنتاج على نطاق واسع، وتقديم تكوين السائل الإلكتروليت الأساسي، ومواد أولية السائل الإلكتروليت، والسائل الإلكتروليت ذو الوظائف الخاصة، وخدمات تكوين السائل الإلكتروليت بكميات كبيرة/خدمات تخصيص السائل الإلكتروليت.",
    "businessIntroTitle": "نظرة عامة على الأنشطة",
    "businessItems": [
      {"title": "السائل الإلكتروليت"},
      {"title": "المُحاليل الكيميائية"},
      {"title": "مواد البطارية"},
      {"title": "السائل الإلكتروليت ذو الوظائف الخاصة"}
    ],
    "caseTabs": [
      {"title": "مصفوفة منتجات واسعة", "description": "أكملت تطوير ما يقرب من مائة نوع من المُضافات الوظيفية لبطارية الليثيوم للطاقة العضوية، ويمكن تقديم سائل إلكتروليت لليثيوم/نтриوم/ملغنيسيوم/ألومينيوم"},
      {"title": "من التطوير والتخصيص إلى الإنتاج بالكميات الكبيرة", "description": "قدرة تصنيع أكثر من 10 نوع من المواد الوظيفية لبطارية الليثيوم، حيث تُقدِّر قدرة الإنتاج التخطيطية لمنتجات سلسلة الأيثوكسينيتريل على مستوى المئات من الطن"},
      {"title": "الاعتماد من شركات التعاون الرائدة", "description": "تتوافق معايير منتجات المُعالجات المُ الصلبة مع المستوى الدولي، وحصلت على الاعتماد من العديد من شركات الطاقة العضوية الرائدة في الصين"}
    ],
    "contactAddress": "العنوان: الطابق 8، مبنى 112، شارع سينغ تشينغ، ميناء سو الصناعي",
    "contactEmail": "البريد الإلكتروني: sales022@b2star.com",
    "contactPhone": "الهاتف: 18136447806",
    "contactPostcode": "الرمز البريدي: 215121",
    "contactQQ": "QQ: 693755679",
    "contactSubtitle": "مزود متكامل لمواد البطارية الل للطاقة العضوية",
    "contactTitle": "اتصل بنا",
    "coreBusinessTitle": "الأنشطة الرئيسية",
    "enterShop": "تعرف المزيد",
    "featureTitle": "ميزات الخدمة",
    "pageSubtitle": "مزود متكامل لمواد البطارية الل للطاقة العضوية",
    "pageTitle": "الطاقة الخضراء",
    "shopSubtitle": "مزود متكامل لمواد البطارية الل للطاقة العضوية",
    "shopTitle": "جودينغ نيو إنرجي (Goodenough New Energy)"
  },
  "news": {
    "searchBtn": "بحث",
    "noNews": "لا توجد أخبار مرتبطة حاليًا",
    "pageTitle": "مركز الأخبار",
    "searchPlaceholder": "الرجاء إدخال الكلمات المفتاحية",
    "title": "أحداث ياكو",
    "topTag": "مُعينًا",
    "viewDetail": "تعرف التفاصيل",
    "viewMore": "عرض المزيد"
  },
  "products": {
    "centerTitle": "مركز المنتجات",
    "detail": {
      "advantages": "مزايا الخدمة",
      "batchInquiry": "استعلام عن الشراء بالكميات الكبيرة",
      "breadcrumbCenter": "مركز المنتجات",
      "breadcrumbHome": "الصفحة الرئيسية",
      "cas": "CAS: {cas}",
      "customSynthesis": "استشارة عن التركيب المُخصص",
      "featured": "المنتجات الشائعة المُوصى بها",
      "features": "ميزات المنتج",
      "getSample": "الحصول على النماذج التجريبية",
      "noData": "لا توجد بيانات حاليًا",
      "notes": "ملاحظات",
      "related": "المنتجات المرتبطة المُوصى بها",
      "researchPurchase": "شراء البحث العلمي"
    },
    "mainProducts": "المنتجات الرئيسية",
    "noData": "لا توجد بيانات حاليًا",
    "searchBtn": "بحث",
    "searchPlaceholder": "الرجاء إدخال اسم المنتج، أو رقم المنتج، أو رقم CAS، أو الكلمات المفتاحية",
    "panel": {
      "EnglishName": "الاسم الإنجليزي",
      "Name": "اسم المنتج",
      "Alias": "الاسم المستعار",
      "CAS": "رقم CAS",
      "UsagePlatform": "منصة الاستخدام",
      "ArtNo": "رقم المنتج",
      "molecularFormula": "الصيغة الجزيئية",
      "molecularWeight": "الوزن الجزيئي",
      "ec": "رقم EC",
      "enzymeActivity": "نشاط الإنزيم",
      "activity": "النشاط"
    }
  },
  "solution": {
    "learnMore": "تعرف المزيد",
    "pageSubtitle": "التقدم التكنولوجي والتحول في مواد الطب والكيمياء",
    "pageTip": "تركز شركة Yacoo دائمًا على دفع التقدم والتجديد التكنولوجي في المواد الطبية والكيميائية. بناءً على الابتكار التكنولوجي والإمداد المستقر، تلبي الاحتياجات المهنية للعملاء، وتوفر منتجات وخدمات متنوعة عالية الجودة ومريحة وبأسعار معقولة، وتعزز التقدم المستمر في صناعة المواد الطبية والكيميائية، وتبني مستقبلًا صحيًا أخضر معًا.",
    "pageTitle": "حلول الصناعة",
    "tableName": "الاسم"
  },
  "sustainability": {
    "conceptText": "تتبع شركة ياكو (Yacoo) دائمًا فلسفة التنمية المستدامة، وتدمج الابتكار الأخضر في جميع خطوات البحث والتطوير، والإنتاج والتشغيل. نحن ملتزمون بتقليل البصمة الكربونية من خلال تحسين العمليات البيئية الصالحة، وتنسيق استخدام الموارد، وتطبيق الطاقة النظيفة؛ ونتشجع على التحول الخضري في الصناعة من خلال الابتكار التكنولوجي لتنمية المواد الحيوية القابلة للتحلل والحلول الخضراء. في نفس الوقت، نحن نựcج المسؤولية الاجتماعية بنشاط، ونجد نظامًا متكاملاً من التعاون مع الموظفين، والمناطق المحيطة، والبيئة، والسعي لتحقيق تنمية متكاملة للفوائد الاقتصادية، والفوائد البيئية، والفوائد الاجتماعية، ويساهم في تحقيق أهداف التنمية المستدامة العالمية.",
    "conceptTitle": "فلسفة التنمية المستدامة",
    "dataSection": {
      "highConcentrationGas": "نسبة استخدام الطاقة النظيفة",
      "lowConcentrationGas": "مقدار الكربون الدايم المعادل/مليون يوان",
      "solidWasteStorage": "التبرع بالكتب لمدرسة كيه تشو二中 في Синجيانج",
      "wastewaterTreatment": "التبرع بالعمل الاجتماعي في عام 2024",
      "units": {
        "cubicMeterPerHour": "%",
        "ton": "طن",
        "tonPerDay": "كتاب",
        "yuan": "يوان"
      }
    },
    "environmentalProtection": {
      "altText": "الحماية البيئية",
      "description": "تتبع شركة ياكو (Yacoo) الدوافع واللوائح المحلية والوطنية المتعلقة بالحماية البيئية والشروط الأخرى، وقد حصلت على شهادة نظام إدارة البيئة ISO14001. تمتلك مُعدنًا شاملاً لمعالجة النفايات الثلاثة (الماء الملوث، والغاز الملوث، والنفايات الصلبة)، وعن طريق استقدام مُعدن معالجة مُتطورة للماء الملوث، والغاز الملوث، والنفايات الصلبة، يمكن الشركة تنفيذ الأنشطة الإنتاجية بأمان مع ضمان الحفاظ على البيئة.",
      "title": "الحماية البيئية"
    },
    "greenDevelopment": {
      "buildingAlt": "مبنى مقر شركة ياكو (Yacoo) الرئيسي",
      "description": "بالتزام بفلسفة الشركة \"تجاوز حدود الطب والكيمياء، وإنشاء مستقبل أخضر معًا\"، تُركز شركة ياكو (Yacoo) دائمًا على التنمية الخضراء سواء في بناء المباني الأساسية أو في تنمية المنتجات. حصل مبنى مقر المجموعة على شهادة LEED (رائدة في التصميم الطاقي والبيئي) من درجات البلاتيني التي منحتها لجنة المباني الخضراء الأمريكية، ويمكنه توفير الطاقة من خلال مُعدن الطاقة الشمسية مثل الألواح الشمسية. تعتمد شركة ياكو (Yacoo) على مادة حيوية قابلة للتحلل المُنتجة من المحاصيل المتجددة (مثل بولي إيثيلين فورميت диكربوكسيلات PEF) التي يمكن استخدامها على نطاق واسع في مجال الزجاجات، مما يقلل بشكل ملحوظ من البصمة الكربونية الكلية خلال عملية إنتاج المنتج.",
      "title": "التنمية الخضراء"
    },
    "pageSubtitle": "خدمات CRO+CDMO المُخصصة لمنتجات الطب والكيمياء",
    "pageTitle": "التنمية المستدامة",
    "safetyProduction": {
      "certificateAlt": "شهادة الاعتماد البيئي",
      "description": "تُ شركة ياكو (Yacoo) نظامًا شاملاً لإدارة الإنتاج الآمن بناءً على متطلبات نظام إدارة السلامة المهنية الصحية ISO45001. تعتمد على مُعدن تكنولوجي ذكي ومُستند إلى المعلومات لحماية خط الحياة الآمن. على سبيل المثال، حصلت موقعة إنتاجية شركة ياكو (Yacoo) في آنجينغ على شهادة التصنيع الآمن من مستوى الثالث، وإنشأت نظامًا معلوماتيًا للإنتاج الآمن، ونجد نظامًا متكاملاً لحماية المخاطر الآمنة من خمسة جوانب مثل تحديد الموظفين، والفحص الذكي، والوقاية المزدوجة، وما إلى ذلك.",
      "title": "الإنتاج الآمن"
    }
  },
  "technology": {
    "achievementsTitle": "نتائج الابتكار",
    "businessIntroText": "تمتلك شركة ياكو (Yacoo) مركز بحث وتطوير بسعة أكثر من 10,000 متر مربع، ومُزود بِمُعدن تكنولوجي متطوري مثل منصة التركيب الذكية بالذكاء الاصطناعي، ومُحول التدفق المستمر المجهري، وتشكيل فريق بحثي مُكون من أكثر من مائة موظف يرأسه الحاصلات على درجات الماجستير والدكتوراه. عن طريق تعزيز التعاون العميق في مجال البحث العلمي والتطبيقية مع معاهد نينجبو الم/ات الصينية، وجامعة سو، وآخرين، أنشأت الشركة منصات الابتكار مثل \"مركز أبحاث وتطوير الصناعة الصينية في كيانغسو\"، و\"مركز التعاون الابتكاري ياكو-JITRI\"، ونجد نظامًا شاملاً للبحث والتطوير وتحويل النتائج. حتى الآن،قد قامت الشركة بتقديم أكثر من 150 براءة اختراعية.",
    "businessIntroTitle": "نظام البحث والتطوير الشامل",
    "businessItems": [
      {"title": "المُعالجات التنقية الحيوية الطبية والمواد الكيميائية البنائية"},
      {"title": "تطوير المُحاليل التشخيصية الخارجية العالية الجودة"},
      {"title": "تطوير الإنزيمات الحيوية"},
      {"title": "تطوير المواد البوليمرية الحيوية العالية الجودة"},
      {"title": "المُحاليل الإلكترونية المستوى الشبه الموصلي ومواد البطارية للطاقة العضوية"}
    ],
    "consultBtn": "استشارة التخصيص",
    "customServiceDesc": "بناءً على تجربة البحث والتطوير البالغة 22 عامًا في مجال مواد الطب والكيمياء، يمكن لشركة ياكو (Yacoo) تقديم خدمات التركيب المُخصص الموثوقة والمستقرة لعملائها.",
    "customServiceTitle": "خدمات التخصيص من مستوى الجرامات إلى مستوى الطن",
    "leadingProcess": "العملية الرائدة",
    "pageTitle": "التكنولوجيا المدفوعة بالذكاء، وإنشاء مستقبل مُبتكر",
    "platformList": [
      {"title": "مختبر ذكي بالذكاء الاصطناعي", "description": "يُركّز مختبر التركيب الذكي بالذكاء الاصطناعي على مُعدن التركيب الذكي بالذكاء الاصطناعي الذي يمكن تخصيص خطوات التفاعل والمعلمات فيه، ومراقبة عملية التفاعل في الوقت الحقيقي، ويمكن تحقيق الاختيار السريع لشروط العملية والتنبؤ بشرط التفاعل الأمثل، وتحسين كفاءة البحث والتطوير."},
      {"title": "مختبر تنقية المُحاليل العالية الجودة", "description": "يُستخدم في تنقية المُحاليل المستوى المساعدة الدوائية ومواد الإلكترونيات المستوى الشبه الموصلي. يُركّز المختبر على مُعدن تنقية متطوري، ويمكن تنفيذ تجارب تقنيات التقطير والترشيح الغشائي للمُركبات مثل الأحماض، والألكوهولات، الأمينات، الأCRYPTات، وما إلى ذلك."},
      {"title": "منصة مختبر لسائل إلكتروليت الطاقة العضوية", "description": "يمكن للمنصة تنفيذ تجارب المُعالجات المُ للسائل الإلكتروليت ومواد السائل الإلكتروليت. تم تجهيزها بِمُعدن، ونجد نجاحًا في تطوير مُعالجات الفوسفازين. يمكن للمنصة تنفيذ التطوير المستمر لمواد البطارية السائلة وشبه السائلة بناءً على مسار تكنولوجي البطارية الخاص بالعميل."},
      {"title": "منصة مختبر تقنية التركيب الحيوي الأخضر", "description": "يُجري التركيب الحيوي في ظروف درجة حرارة عادية وضغط عادي، وينمخن استهلاك الطاقة، و لا يحتاج إلى مُذيب عضوي، وينقص أو يُزيل المنتجات побعية السامة. تُركز هذه المنصة على تطوير منتجات المخازن الحيوية المُصنعة من تقنية التحفيز الإنزيمي، وتطوير أنظمة تشخيصية جديدة ومواد بوليمرية حيوية."},
      {"title": "منصة مختبر التركيب الكيميائي", "description": "يُركّز مختبر التركيب الكيميائي على مُعدن التركيب التقليدي، بالإضافة إلى مُعدن متطوري مثل مقاييس الرنين المغناطيسي النووي (NMR)، ومقاييس الكتلة (MS)، ومقاييس الكروماتوجرافيا السائلة العالية الكفاءة (HPLC)، ومُحول التدفق المستمر المجهري المحوسب التلقائي، و نظام إدارة بيانات المختبر (LIMS). يمكن تنفيذ تطوير المواد المساعدة الدوائية، وأنظمة التشخيص الخارجية، ومواد مركبة بوليمرية حيوية، بما في ذلك التطوير المُخصص للعميل."}
    ],
    "platformTitle": "خمسة منصات بحث وتطوير ذكية",
    "serviceIcons": ["المُعالجات التنقية الحيوية الطبية والمواد الكيميائية البنائية", "تطوير المُحاليل التشخيصية الخارجية العالية الجودة", "تطوير الإنزيمات الحيوية", "تطوير المواد البوليمرية الحيوية العالية الجودة", "المُحاليل الإلكترونية المستوى الشبه الموصلي ومواد البطارية للطاقة العضوية"],
    "starProduct": "المنتجات الابتكارية"
  },
  "footer": {
    "contact": {
      "phone": "الهاتف",
      "email": "البريد الإلكتروني"
    },
    "qrCode": {
      "scanToFollow": "اسحب الرمز الشريطي لمتابعةنا"
    },
    "socialMedia": {
      "wechat": "ويتشات",
      "tiktok": "تيك توك",
      "xiaohongshu": "سياو هونغ شو "
    },
    "copyright": "© 2025 شركة ياكو تكنولوجيا سو المحدودة [رقم الترخيص الصيني苏ICP备15045967号]"
  },
  "croCdmoDialog": {
    "logoAlt": "شارة ياكو (Yacoo)",
    "hotline": "خط الدعم المجاني:",
    "description": "يرجى ترك معلومات احتياجاتك، وسنتصل بك في خلال يوم عمل واحد",
    "form": {
      "name": "الاسم",
      "namePlaceholder": "يرجى إدخال اسمك",
      "contact": "معلومات الاتصال",
      "contactPlaceholder": "يرجى إدخال رقم هاتفك/رقم هاتف الجوال/بريدك الإلكتروني",
      "company": "اسم الشركة",
      "companyPlaceholder": "يرجى إدخال اسم شركتك",
      "product": "اسم المنتج",
      "productPlaceholder": "يرجى إدخال اسم المنتج",
      "cas": "رقم CAS",
      "casPlaceholder": "يرجى إدخال رقم CAS",
      "requirement": "احتياجات الشراء",
      "requirementPlaceholder": "يرجى إدخال احتياجات شرائك",
      "attachment": "المرفق",
      "submit": "إرسال"
    },
    "upload": {
      "clickToUpload": "انقر لتحميل المرفق",
      "fileFormat": "تنسيق الملف: jpg、pdf、doc، الحد الأقصى لحجم الملف 5 ميجابايت",
      "fileSizeError": "لا يمكن أن يزيد حجم الملف عن 5 ميجابايت",
      "fileTypeError": "يرجى تحميل ملف بتنسيق jpg、pdf أو doc",
      "uploadSuccess": "نجاح تحميل الملف",
      "uploadFailed": "فشل تحميل الملف، يرجى المحاولة مرة أخرى"
    },
    "validation": {
      "nameRequired": "يرجى إدخال الاسم",
      "contactRequired": "يرجى إدخال معلومات الاتصال",
      "casRequired": "يرجى إدخال رقم CAS"
    },
    "messages": {
      "submitSuccess": "نجاح الإرسال",
      "submitFailed": "فشل الإرسال",
      "submitFailedRetry": "فشل الإرسال، يرجى المحاولة لاحقًا"
    }
  },
  "productDialog": {
    "logoAlt": "شارة ياكو (Yacoo)",
    "hotline": "خط الدعم المجاني:",
    "description": "يرجى ترك معلومات احتياجاتك، وسنتصل بك في خلال يوم عمل واحد",
    "form": {
      "name": "الاسم",
      "namePlaceholder": "يرجى إدخال اسمك",
      "contact": "معلومات الاتصال",
      "contactPlaceholder": "يرجى إدخال رقم هاتفك/رقم هاتف الجوال/بريدك الإلكتروني",
      "company": "اسم الشركة",
      "companyPlaceholder": "يرجى إدخال اسم شركتك",
      "product": "اسم المنتج",
      "productPlaceholder": "يرجى إدخال اسم المنتج",
      "cas": "رقم CAS",
      "casPlaceholder": "يرجى إدخال رقم CAS",
      "requirement": "احتياجات الشراء",
      "requirementPlaceholder": "يرجى إدخال احتياجات شرائك",
      "submit": "إرسال"
    },
    "validation": {
      "nameRequired": "يرجى إدخال الاسم",
      "contactRequired": "يرجى إدخال معلومات الاتصال",
      "casRequired": "يرجى إدخال رقم CAS"
    },
    "messages": {
      "submitSuccess": "نجاح الإرسال",
      "submitFailed": "فشل الإرسال",
      "submitFailedRetry": "فشل الإرسال، يرجى المحاولة لاحقًا"
    }
  },
  "serviceDialog": {
    "logoAlt": "شارة ياكو (Yacoo)",
    "hotline": "خط الدعم المجاني:",
    "description": "يرجى ترك معلومات احتياجاتك، وسنتصل بك في خلال يوم عمل واحد",
    "form": {
      "name": "الاسم",
      "namePlaceholder": "يرجى إدخال اسمك",
      "contact": "معلومات الاتصال",
      "contactPlaceholder": "يرجى إدخال رقم هاتفك/رقم هاتف الجوال/بريدك الإلكتروني",
      "company": "اسم الشركة",
      "companyPlaceholder": "يرجى إدخال اسم شركتك",
      "service": "اسم الخدمة",
      "servicePlaceholder": "يرجى إدخال اسم الخدمة",
      "requirement": "تفاصيل الاحتياج",
      "requirementPlaceholder": "يرجى إدخال احتياجات التخصيص الخاصة بك",
      "submit": "إرسال"
    },
    "validation": {
      "nameRequired": "يرجى إدخال الاسم",
      "contactRequired": "يرجى إدخال معلومات الاتصال"
    },
    "messages": {
      "submitSuccess": "نجاح الإرسال",
      "submitFailed": "فشل الإرسال",
      "submitFailedRetry": "فشل الإرسال، يرجى المحاولة لاحقًا"
    }
  },
  "purchaseDialog": {
    "logoAlt": "شارة ياكو (Yacoo)",
    "title": "المزيد من منتجات العلامات التجارية، متوفرة في منصة ب2ستار ",
    "gotoStore": "الانتقال إلى المتجر لعرض",
    "storeInfo": "تقديم الخدمة من قبل منصة ب2ستار التابعة لمجموعة ياكو (Yacoo)"
  },
  "purchaseListDialog": {
    "logoAlt": "شارة ياكو (Yacoo)",
    "productInfo": "معلومات المنتج",
    "unitPrice": "السعر الواحد (شامل الضريبة)",
    "more": "المزيد",
    "productCode": "رقم المنتج:",
    "itemNumber": "رقم الصنف:",
    "specification": "المواصفات:",
    "parameter": "المَعلمات:",
    "contactSales": "الاتصال بالمبيعات لاستعلام السعر",
    "gotoShop": "الانتقال إلى المتجر لعرض",
    "storeInfo": "تقديم الخدمة من قبل منصة ب2ستار التابعة لمجموعة ياكو (Yacoo)"
  },
  "resumeDialog": {
    "logoAlt": "ياكو (Yacoo)",
    "upload": {
      "clickToUpload": "انقر لتحميل السيرة الذاتية",
      "fileFormat": "تنسيق الملف: jpg、pdf、ppt، الحد الأقصى لحجم الملف 5 ميجابايت",
      "fileSizeError": "لا يمكن أن يزيد حجم الملف عن 5 ميجابايت",
      "fileTypeError": "يرجى تحميل ملف بتنسيق jpg、pdf أو ppt"
    },
    "fileInfo": {
      "removeFile": "حذف الملف"
    },
    "submit": "إرسال",
    "messages": {
      "uploadSuccess": "نجاح تقديم السيرة الذاتية",
      "uploadFailed": "فشل التحميل، يرجى المحاولة مرة أخرى",
      "jobNotExist": "معلومات الوظيفة غير موجودة",
      "pleaseUploadFirst": "يرجى تحميل السيرة الذاتية أولاً"
    }
  },
  "goodChart": {
    "logoAlt": "شارة ياكو (Yacoo)",
    "companyName": "شركة ياكو (Yacoo)",
    "consultationPhone": "رقم الهاتف الاستشاري:",
    "productService": "استشارات المنتج وخدمات الدعم:",
    "contactEmail": "البريد الإلكتروني للاتصال:",
    "leaveMessage": "اترك رسالة"
  },
  "searchPage": {
    "pageTitle": "بحث في جميع المواقع",
    "searchInfo": "بحث عن: {keyword}",
    "loading": "جارٍ التحميل...",
    "noData": "لا توجد بيانات حاليًا",
    "noNews": "لا توجد أخبار مرتبطة حاليًا",
    "noProducts": "لا توجد منتجات مرتبطة حاليًا",
    "productInfo": {
      "casNo": "رقم CAS:",
      "itemNumber": "رقم الصنف:",
      "specification": "المواصفات:",
      "parameter": "المَعلمات:",
      "price": "السعر:",
      "unit": "الوحدة:",
      "inquiry": "استعلام",
      "chemicalName": "الاسم الكيميائي"
    },
    "newsInfo": {
      "typeTag": "وسم النوع"
    },
    "pagination": {
      "prev": "الصفحة السابقة",
      "next": "الصفحة التالية"
    }
  }
};

